import { equals } from '@execonline-inc/collections';
import { Maybe, just, nothing } from 'maybeasy';
import { TPlainTextKey } from '../../../../../Translations';
import { ParticipantAndGroupOptionResource, State } from './Types';

export const isLoading = (state: State) => {
  switch (state.kind) {
    case 'loading':
    case 'filtering':
      return true;
    case 'ready':
    case 'filtered':
    case 'option-selected':
    case 'error':
      return false;
  }
};

export const options = (state: State) => {
  switch (state.kind) {
    case 'loading':
    case 'ready':
    case 'filtering':
    case 'error':
      return [];
    case 'filtered':
      return state.optionsResource.payload;
    case 'option-selected':
      const { selectedValue, optionsResource } = state;
      return optionsResource.payload.filter(equals(selectedValue));
  }
};

export const getPlaceholder = (placeholder: TPlainTextKey, state: State) => {
  switch (state.kind) {
    case 'filtered':
    case 'option-selected':
    case 'ready':
      return placeholder;
    case 'loading':
    case 'filtering':
      return 'Loading...';
    case 'error':
      return '';
  }
};

export const selectedValue = (state: State): Maybe<ParticipantAndGroupOptionResource> => {
  switch (state.kind) {
    case 'loading':
    case 'ready':
    case 'filtering':
      return nothing();
    case 'filtered':
      return state.selectedValue;
    case 'option-selected':
      return just(state.selectedValue);
    case 'error':
      return nothing();
  }
};
